export default "__VITE_ASSET__CXtUoa0t__"